var React = require('react');

function CheckmarkIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.07104 12.3077L16 1.29902L14.7104 0L5.07104 9.73166L1.26776 5.90065L0 7.19967L5.07104 12.3077Z","fill":"#454545"}));
}

CheckmarkIcon.defaultProps = {"width":"16","height":"13","viewBox":"0 0 16 13","fill":"none"};

module.exports = CheckmarkIcon;

CheckmarkIcon.default = CheckmarkIcon;
